import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Description } from '../styled/Description';
import { DeleteButton } from '../styled/DeleteButton';
import axios from 'axios';

const RoomItemStyled = styled.li`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    width: 100%;
    padding: 0.7rem 1.2rem;
    list-style: none;
    cursor: pointer;
    transition: all 0.15s ease;
    border-left: 3px solid ${props => props.active ? '#6366f1' : 'transparent'};
    background: ${props => props.active ? 'rgba(99, 102, 241, 0.12)' : 'transparent'};

    &:hover {
        background: rgba(255, 255, 255, 0.04);
    }

    pointer-events: ${props => props.isLoading ? 'none' : 'auto'};
    cursor: ${props => props.isLoading ? 'default' : 'pointer'};
`;

const RoomItemTopSection = styled.div`
    display: flex;
    gap: 0.7rem;
    align-items: center;
    width: 100%;
`;

const RoomItemDescription = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;

    & span {
        font-weight: 500;
        font-size: 0.9em;
        color: rgba(255, 255, 255, 0.85);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

const UnreadCountBadge = styled.div`
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: white;
    border-radius: 10px;
    padding: 0.15em 0.55em;
    font-size: 0.7em;
    font-weight: 600;
    flex-shrink: 0;
    min-width: 1.4em;
    text-align: center;
`;

const RoomItem = ({ room, isActive, handleClick, showDeleteIcon, handleDelete, unreadMessagesCount, updateRoomImage }) => {
    const { id, name, image, description } = room;
    const [isLoading, setIsLoading] = useState(!image);

    useEffect(() => {
        if (!image) { startPolling(); }
    }, []);

    const startPolling = async () => {
        let intervalId = setInterval(async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER}/rooms/${id}/status`, { withCredentials: true });
                if (response.data.success && response.data.status === 'completed') {
                    updateRoomImage(id, response.data.image);
                    setIsLoading(false);
                    clearInterval(intervalId);
                }
            } catch (error) {
                console.error('Error fetching room image:', error);
                clearInterval(intervalId);
            }
        }, 5000);
        return () => clearInterval(intervalId);
    };

    return (
        <RoomItemStyled active={isActive} onClick={() => handleClick(id)} isLoading={isLoading}>
            <RoomItemTopSection>
                <RoomItemDescription>
                    <span>{name}</span>
                    <Description color='rgba(255,255,255,0.35)' size='0.7em'>{description}</Description>
                </RoomItemDescription>
                {unreadMessagesCount > 0 && <UnreadCountBadge>{unreadMessagesCount}</UnreadCountBadge>}
                {showDeleteIcon && <DeleteButton onClick={(e) => { e.stopPropagation(); handleDelete(id, name); }} />}
            </RoomItemTopSection>
        </RoomItemStyled>
    );
};

export default RoomItem;
